import { Subject } from 'rxjs';
import type { EventName } from 'amazon-chime-sdk-js';

import type { DeafDisconnected } from 'features/call/call-deaf/interfaces';
import type {
  HearingPhone,
  HearingPhoneWithDisconnectReason,
  HearingPhoneWithId,
} from 'features/call/call-hearing/interfaces';
import type { AcceptedEvent } from 'features/sip/interfaces';

export interface MeetingError {
  name: EventName;
  message: string;
}

export class ParticipantsStatusEventBus {
  static readonly hearing = {
    $connecting: new Subject<HearingPhone>(),
    $connectingId: new Subject<HearingPhoneWithId>(),
    $connected: new Subject<HearingPhoneWithId>(),
    $disconnected: new Subject<HearingPhoneWithDisconnectReason>(),
    $startInterpretingTime: new Subject<string>(),
    $connectedToWebsocket: new Subject<void>(),
  };
  static readonly deaf = {
    $connecting: new Subject<void>(),
    $connected: new Subject<AcceptedEvent>(),
    $disconnected: new Subject<DeafDisconnected>(),
    $unavailable: new Subject<void>(),
    $disconnectSignMail: new Subject<void>(),
    $connectSignMail: new Subject<void>(),
  };
  static readonly $meetingError = new Subject<MeetingError>();
}
